<div *ngIf="nodeValue" class="bg-bluegray-50 h-full">
   <!-- Header -->
   <div
      class="bg-white flex flex-column justify-content-between align-items-center gap-3 w-full px-4 border-bottom-1 border-200"
   >
      <span class="cursor-pointer w-full justify-content-end flex pt-4 mr-2" (click)="this.closeSidebar.emit()">
         <i class="text-bluegray-800 pi pi-times"></i>
      </span>

      <div class="flex justify-content-start align-items-center w-full gap-3 pb-3">
         <div class="bg-blue-50 p-3 border-1 border-blue-100 border-round-lg">
            <i class="pi pi-phone text-blue-700 text-lg"></i>
         </div>
         <div class="text-2xl text-700 font-semibold flex flex-column gap-1">
            {{ 'DATA.MODULES.INSPECTORS.MAKE_OUTBOUND_CALL.TITLE' | translate }}
            <div class="text-sm font-normal text-600">
               {{ 'DATA.MODULES.INSPECTORS.MAKE_OUTBOUND_CALL.DESCRIPTION' | translate }}
            </div>
         </div>
      </div>

      <div class="flex justify-content-center mb-4">
         <p-selectButton
            [options]="visibleTabs()"
            [ngModel]="activeTab()"
            (ngModelChange)="activeTab.set($event)"
            optionLabel="label"
            optionValue="value"
         ></p-selectButton>
      </div>
   </div>

   <!-- Preview Tab -->
   <div *ngIf="activeTab() === 'preview'" class="p-4 overflow-auto h-80">
      <div class="flex flex-column gap-4">
         <div class="flex flex-column gap-4">
            <div>
               <div class="surface-card p-4 border-1 border-round-xl border-200 bg-white shadow-1">
                  <div class="flex flex-column gap-3">
                     <div class="flex justify-content-start align-items-center w-full gap-3 mb-2">
                        <div class="flex flex-column gap-1">
                           <span class="font-semibold text-900">Resumen de configuración</span>
                           <span class="text-xs text-600">{{
                              'DATA.MODULES.INSPECTORS.MAKE_OUTBOUND_CALL.PREVIEW.SUBTITLE' | translate
                           }}</span>
                        </div>
                     </div>

                     <div class="flex flex-column gap-3">
                        <div class="flex align-items-center gap-3">
                           <div
                              class="bg-blue-50 border-round-xl flex align-items-center justify-content-center w-3rem h-3rem"
                           >
                              <i class="pi pi-user text-blue-700"></i>
                           </div>
                           <div class="flex flex-column">
                              <span class="text-sm text-600">{{
                                 'DATA.MODULES.INSPECTORS.MAKE_OUTBOUND_CALL.PREVIEW.AGENT' | translate
                              }}</span>
                              <span class="text-lg font-semibold text-900">{{
                                 selectedAgentDetails()?.name || '-'
                              }}</span>
                           </div>
                        </div>

                        <div class="flex align-items-center gap-3">
                           <div
                              class="bg-cyan-50 border-round-xl flex align-items-center justify-content-center w-3rem h-3rem"
                           >
                              <i class="pi pi-users text-cyan-700 text-lg"></i>
                           </div>
                           <div class="flex flex-column">
                              <span class="text-sm text-600">{{
                                 'DATA.MODULES.INSPECTORS.MAKE_OUTBOUND_CALL.PREVIEW.CONTACT_ALL' | translate
                              }}</span>
                              <span
                                 class="text-lg font-semibold"
                                 [ngClass]="isContactAll() ? 'text-green-700' : 'text-gray-700'"
                                 >{{
                                    isContactAll()
                                       ? ('DATA.MODULES.INSPECTORS.MAKE_OUTBOUND_CALL.PREVIEW.YES' | translate)
                                       : ('DATA.MODULES.INSPECTORS.MAKE_OUTBOUND_CALL.PREVIEW.NO' | translate)
                                 }}</span
                              >
                           </div>
                        </div>

                        <div class="flex align-items-center gap-3">
                           <div
                              class="bg-teal-50 border-round-xl flex align-items-center justify-content-center w-3rem h-3rem"
                           >
                              <i class="pi pi-refresh text-teal-700 text-lg"></i>
                           </div>
                           <div class="flex flex-column">
                              <span class="text-sm text-600">{{
                                 'DATA.MODULES.INSPECTORS.MAKE_OUTBOUND_CALL.PREVIEW.RETRY' | translate
                              }}</span>
                              <span
                                 class="text-lg font-semibold"
                                 [ngClass]="isRetryFailCalls() ? 'text-teal-700' : 'text-gray-700'"
                                 >{{
                                    isRetryFailCalls()
                                       ? ('DATA.MODULES.INSPECTORS.MAKE_OUTBOUND_CALL.PREVIEW.YES' | translate)
                                       : ('DATA.MODULES.INSPECTORS.MAKE_OUTBOUND_CALL.PREVIEW.NO' | translate)
                                 }}</span
                              >
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>

            <!-- Retry slots card -->
            <div *ngIf="isRetryFailCalls()">
               <div class="surface-card p-4 border-1 border-round-xl border-200 bg-white shadow-1">
                  <div class="flex align-items-center gap-3 mb-4">
                     <div class="flex flex-column">
                        <span class="font-semibold text-800">{{
                           'DATA.MODULES.INSPECTORS.MAKE_OUTBOUND_CALL.PREVIEW.RETRY_SLOTS_TITLE' | translate
                        }}</span>
                        <span class="text-500 text-sm">{{
                           'DATA.MODULES.INSPECTORS.MAKE_OUTBOUND_CALL.PREVIEW.RETRY_SLOTS_SUBTITLE' | translate
                        }}</span>
                     </div>
                  </div>

                  <div *ngIf="isRetryFailCalls()">
                     <div class="flex flex-column gap-3">
                        <ng-container *ngFor="let range of retryTimeRanges(); let i = index">
                           <div
                              *ngIf="range.selected"
                              class="p-3 border-round-lg bg-indigo-50 flex gap-3 align-items-center shadow-1"
                           >
                              <div
                                 class="border-round-xl flex align-items-center justify-content-center w-2.5rem h-2.5rem"
                              >
                                 <i class="pi pi-clock text-indigo-700 text-lg"></i>
                              </div>
                              <div class="flex flex-column">
                                 <span class="text-sm text-600">{{
                                    'DATA.MODULES.INSPECTORS.MAKE_OUTBOUND_CALL.PREVIEW.RETRY_LABEL'
                                       | translate: { number: i + 1 }
                                 }}</span>
                                 <span class="text-lg font-semibold">{{ range.from }} - {{ range.to }}</span>
                              </div>
                           </div>
                        </ng-container>
                     </div>
                  </div>
               </div>
            </div>

            <!-- Actions card -->
            <div>
               <div class="surface-card p-4 border-1 border-round-xl border-200 bg-white shadow-1">
                  <div class="flex align-items-center gap-3 mb-4">
                     <div class="flex flex-column">
                        <span class="font-semibold text-800">{{
                           'DATA.MODULES.INSPECTORS.MAKE_OUTBOUND_CALL.PREVIEW.ACTIONS' | translate
                        }}</span>
                        <span class="text-500 text-sm">Acciones que se realizarán durante la llamada</span>
                     </div>
                  </div>

                  <div class="flex flex-column gap-3">
                     <div *ngFor="let action of actions()" class="p-3 border-round bg-blue-50 shadow-1">
                        <div class="flex align-items-center gap-3">
                           <div
                              class="bg-white border-round w-2.5rem h-2.5rem flex align-items-center justify-content-center"
                           >
                              <i class="pi pi-directions text-blue-700 text-lg"></i>
                           </div>
                           <div class="flex flex-column">
                              <span class="text-sm text-600 font-italic">{{ action.situation || '-' }}</span>
                              <span class="text-md font-semibold text-blue-900">{{
                                 action.action === 'feedback'
                                    ? ('DATA.MODULES.INSPECTORS.MAKE_OUTBOUND_CALL.CONFIG.ACTIONS.OPTIONS.FEEDBACK'
                                      | translate)
                                    : ('DATA.MODULES.INSPECTORS.MAKE_OUTBOUND_CALL.CONFIG.ACTIONS.OPTIONS.ASSIGN_CAMPAIGN'
                                      | translate)
                              }}</span>
                              <div *ngIf="action.action === 'assignCampaign'" class="text-xs text-blue-700 mt-1">
                                 a
                                 <a (click)="viewCampaign(action.campaign)" class="text-primary hover:underline"
                                    >{{ getCampaignName(action.campaign) }}
                                    <i class="pi pi-external-link text-primary text-xs"></i
                                 ></a>
                              </div>
                           </div>
                        </div>
                     </div>

                     <div
                        *ngIf="actions().length === 0"
                        class="p-3 bg-gray-50 border-round text-500 text-sm italic flex align-items-center gap-2"
                     >
                        <i class="pi pi-info-circle"></i>
                        Sin acciones configuradas
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>

   <!-- Config Tab -->
   <div *ngIf="activeTab() === 'config'" class="p-4 overflow-auto h-80">
      <div class="flex flex-column gap-5">
         <section class="flex flex-column gap-3">
            <div class="flex flex-column gap-1">
               <span class="font-semibold text-900">{{
                  'DATA.MODULES.INSPECTORS.MAKE_OUTBOUND_CALL.CONFIG.AGENT_SECTION.TITLE' | translate
               }}</span>
               <span class="text-sm text-500">{{
                  'DATA.MODULES.INSPECTORS.MAKE_OUTBOUND_CALL.CONFIG.AGENT_SECTION.SUBTITLE' | translate
               }}</span>
            </div>
            <p-dropdown
               [options]="agents()"
               [ngModel]="selectedAgentId()"
               (ngModelChange)="onAgentChange($event)"
               optionLabel="name"
               optionValue="id"
               [placeholder]="
                  'DATA.MODULES.INSPECTORS.MAKE_OUTBOUND_CALL.CONFIG.AGENT_SECTION.DROPDOWN_LABEL' | translate
               "
               class="w-full"
               styleClass="w-full"
            ></p-dropdown>

            <!-- Agent Info Card -->
            <div
               *ngIf="selectedAgentDetails()"
               class="surface-card p-4 border-1 border-round-xl border-200 bg-white flex flex-column gap-3 mt-2"
            >
               <div class="flex align-items-center gap-3 mb-2">
                  <div class="bg-blue-50 p-3 border-1 border-blue-100 border-round-lg">
                     <i class="pi pi-user text-blue-700 text-lg"></i>
                  </div>
                  <div class="flex flex-column">
                     <span class="text-900 font-bold text-lg leading-tight">{{ selectedAgentDetails().name }}</span>
                     <span class="text-600 text-xs">Proveedor: {{ selectedAgentDetails().provider }}</span>
                  </div>
               </div>

               <div class="flex justify-content-between">
                  <span class="text-600 text-sm">{{
                     'DATA.MODULES.INSPECTORS.MAKE_OUTBOUND_CALL.CONFIG.AGENT_SECTION.INFO.EXTERNAL_ID' | translate
                  }}</span>
                  <div class="flex align-items-center gap-2">
                     <span class="text-900 font-medium">{{ selectedAgentDetails().externalId }}</span>
                     <i
                        class="pi pi-copy text-500 cursor-pointer hover:text-primary"
                        (click)="copyToClipboard(selectedAgentDetails().externalId)"
                     ></i>
                  </div>
               </div>
               <div class="flex justify-content-between">
                  <span class="text-600 text-sm">{{
                     'DATA.MODULES.INSPECTORS.MAKE_OUTBOUND_CALL.CONFIG.AGENT_SECTION.INFO.NAME' | translate
                  }}</span>
                  <span class="text-900 font-medium">{{ selectedAgentDetails().name }}</span>
               </div>
               <div class="flex justify-content-between">
                  <span class="text-600 text-sm">{{
                     'DATA.MODULES.INSPECTORS.MAKE_OUTBOUND_CALL.CONFIG.AGENT_SECTION.INFO.VOICE_ID' | translate
                  }}</span>
                  <span class="text-900 font-medium">{{ selectedAgentDetails().config?.voiceId || '-' }}</span>
               </div>
               <div class="flex flex-column gap-1">
                  <span class="text-600 text-sm">{{
                     'DATA.MODULES.INSPECTORS.MAKE_OUTBOUND_CALL.CONFIG.AGENT_SECTION.INFO.PROMPT_URL' | translate
                  }}</span>
                  <span class="text-900 font-medium text-xs break-all">{{
                     selectedAgentDetails().promptUrl || '-'
                  }}</span>
               </div>
            </div>
         </section>

         <p-divider></p-divider>

         <section class="flex flex-column gap-3">
            <div class="flex align-items-center gap-2">
               <p-checkbox
                  [(ngModel)]="isContactAll"
                  [binary]="true"
                  (onChange)="applyChanges()"
                  id="isContactAll"
               ></p-checkbox>
               <label for="isContactAll" class="text-800 text-normal">{{
                  'DATA.MODULES.INSPECTORS.MAKE_OUTBOUND_CALL.CONFIG.CONTACT_ALL.LABEL' | translate
               }}</label>
            </div>

            <div class="flex align-items-center gap-2">
               <p-checkbox
                  [(ngModel)]="isRetryFailCalls"
                  [binary]="true"
                  (onChange)="applyChanges()"
                  id="isRetryFailCalls"
               ></p-checkbox>
               <label for="isRetryFailCalls" class="text-800 text-normal">{{
                  'DATA.MODULES.INSPECTORS.MAKE_OUTBOUND_CALL.CONFIG.RETRY_FAIL_CALLS.LABEL' | translate
               }}</label>
            </div>
         </section>

         <section *ngIf="isRetryFailCalls()" class="flex flex-column gap-4 pl-4">
            <span class="font-semibold text-sm text-700">{{
               'DATA.MODULES.INSPECTORS.MAKE_OUTBOUND_CALL.CONFIG.RETRY_FAIL_CALLS.SECTION_TITLE' | translate
            }}</span>
            <div class="flex flex-column gap-3">
               <div *ngFor="let range of retryTimeRanges(); let i = index" class="w-full">
                  <div class="surface-card p-3 border-1 border-round-lg border-200 flex flex-column gap-3">
                     <div class="flex align-items-center gap-2">
                        <p-checkbox
                           [(ngModel)]="range.selected"
                           [binary]="true"
                           (onChange)="onRetryRangeChange()"
                           [id]="'retry-' + i"
                        ></p-checkbox>
                        <label [for]="'retry-' + i" class="font-medium text-sm">
                           <i class="pi pi-clock text-600 text-xs"></i>
                           {{
                              'DATA.MODULES.INSPECTORS.MAKE_OUTBOUND_CALL.CONFIG.RETRY_FAIL_CALLS.RETRY_LABEL'
                                 | translate: { number: i + 1 }
                           }}</label
                        >
                     </div>
                     <div *ngIf="range.selected" class="flex gap-4">
                        <div class="flex flex-column gap-1 flex-1">
                           <span class="text-xs text-500">{{
                              'DATA.MODULES.INSPECTORS.MAKE_OUTBOUND_CALL.CONFIG.RETRY_FAIL_CALLS.FROM' | translate
                           }}</span>
                           <input
                              pInputText
                              type="time"
                              [(ngModel)]="range.from"
                              (change)="onRetryRangeChange()"
                              class="p-inputtext-sm"
                           />
                        </div>
                        <div class="flex flex-column gap-1 flex-1">
                           <span class="text-xs text-500">{{
                              'DATA.MODULES.INSPECTORS.MAKE_OUTBOUND_CALL.CONFIG.RETRY_FAIL_CALLS.TO' | translate
                           }}</span>
                           <input
                              pInputText
                              type="time"
                              [(ngModel)]="range.to"
                              (change)="onRetryRangeChange()"
                              class="p-inputtext-sm"
                           />
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </section>

         <p-divider></p-divider>

         <section class="flex flex-column gap-3">
            <div class="flex justify-content-between align-items-center">
               <div class="flex flex-column gap-1">
                  <span class="font-semibold text-900">{{
                     'DATA.MODULES.INSPECTORS.MAKE_OUTBOUND_CALL.CONFIG.ACTIONS.TITLE' | translate
                  }}</span>
                  <span class="text-xs text-500"
                     >Define acciones automáticas basadas en el resultado de la llamada.</span
                  >
               </div>
               <p-button
                  [label]="'DATA.MODULES.INSPECTORS.MAKE_OUTBOUND_CALL.CONFIG.ACTIONS.ADD_BUTTON' | translate"
                  icon="pi pi-plus"
                  size="small"
                  text="true"
                  severity="primary"
                  (onClick)="addAction()"
               ></p-button>
            </div>

            <div class="flex flex-column gap-3">
               <div *ngFor="let action of actions(); let i = index">
                  <div
                     *ngIf="!editingActions().has(i)"
                     class="surface-card p-4 border-1 border-round-xl border-200 bg-blue-50 relative flex flex-column gap-2 shadow-1 border-left-3 border-blue-500"
                  >
                     <div class="absolute top-0 right-0 p-3 flex gap-2">
                        <p-button
                           icon="pi pi-pencil"
                           [severity]="'secondary'"
                           [rounded]="true"
                           size="small"
                           [outlined]="false"
                           (click)="editAction(i)"
                        >
                        </p-button>
                        <p-button
                           icon="pi pi-trash"
                           [severity]="'secondary'"
                           [rounded]="true"
                           [outlined]="false"
                           size="small"
                           (click)="removeAction(i)"
                        >
                        </p-button>
                     </div>

                     <div class="flex flex-column gap-1">
                        <span class="text-xs font-semibold text-500 uppercase">{{
                           'DATA.MODULES.INSPECTORS.MAKE_OUTBOUND_CALL.CONFIG.ACTIONS.IF_THIS_HAPPENS' | translate
                        }}</span>
                        <span class="text-sm font-bold text-blue-900">{{ action.situation || '-' }}</span>
                     </div>

                     <div class="flex flex-column gap-1">
                        <span class="text-xs font-semibold text-500 uppercase">{{
                           'DATA.MODULES.INSPECTORS.MAKE_OUTBOUND_CALL.CONFIG.ACTIONS.SYSTEM_ACTION' | translate
                        }}</span>
                        <div class="text-sm text-blue-700">
                           {{
                              (action.action === 'feedback'
                                 ? 'DATA.MODULES.INSPECTORS.MAKE_OUTBOUND_CALL.CONFIG.ACTIONS.OPTIONS.FEEDBACK'
                                 : 'DATA.MODULES.INSPECTORS.MAKE_OUTBOUND_CALL.CONFIG.ACTIONS.OPTIONS.ASSIGN_CAMPAIGN'
                              ) | translate
                           }}
                           <span *ngIf="action.action === 'assignCampaign'" class="font-semibold">
                              :
                              <a
                                 (click)="viewCampaign(action.campaign)"
                                 class="text-primary cursor-pointer hover:underline"
                                 >{{ getCampaignName(action.campaign) }}
                                 <i class="pi pi-external-link text-primary text-sm"></i
                              ></a>
                           </span>
                        </div>
                     </div>
                  </div>

                  <div
                     *ngIf="editingActions().has(i)"
                     [id]="'action-form-' + i"
                     class="surface-card p-4 border-1 border-round-xl border-200 bg-white relative flex flex-column gap-3 shadow-1"
                  >
                     <div class="absolute top-0 right-0 p-3 flex gap-4">
                        <p-button
                           icon="pi pi-trash"
                           [severity]="'danger'"
                           [rounded]="true"
                           size="small"
                           [outlined]="true"
                           (click)="removeAction(i)"
                        >
                        </p-button>
                     </div>

                     <div class="flex flex-column gap-1 pt-3">
                        <span class="text-sm font-semibold text-700">{{
                           'DATA.MODULES.INSPECTORS.MAKE_OUTBOUND_CALL.CONFIG.ACTIONS.IF_THIS_HAPPENS' | translate
                        }}</span>
                        <input
                           pInputText
                           [(ngModel)]="action.situation"
                           placeholder="Ej: No contesta, Interesado..."
                           class="w-full"
                        />
                     </div>

                     <div class="flex flex-column gap-1">
                        <span class="text-sm font-semibold text-700">{{
                           'DATA.MODULES.INSPECTORS.MAKE_OUTBOUND_CALL.CONFIG.ACTIONS.SYSTEM_ACTION' | translate
                        }}</span>
                        <p-selectButton
                           [options]="[
                              {
                                 label:
                                    'DATA.MODULES.INSPECTORS.MAKE_OUTBOUND_CALL.CONFIG.ACTIONS.OPTIONS.FEEDBACK'
                                    | translate,
                                 value: 'feedback'
                              },
                              {
                                 label:
                                    'DATA.MODULES.INSPECTORS.MAKE_OUTBOUND_CALL.CONFIG.ACTIONS.OPTIONS.ASSIGN_CAMPAIGN'
                                    | translate,
                                 value: 'assignCampaign'
                              }
                           ]"
                           [(ngModel)]="action.action"
                           optionLabel="label"
                           optionValue="value"
                           class="block w-full"
                           styleClass="w-full"
                        ></p-selectButton>
                     </div>

                     <div *ngIf="action.action === 'assignCampaign'" class="flex flex-column gap-1">
                        <span class="text-sm font-semibold text-700">{{
                           'DATA.MODULES.INSPECTORS.MAKE_OUTBOUND_CALL.CONFIG.ACTIONS.SELECT_CAMPAIGN' | translate
                        }}</span>
                        <app-tree-select
                           [nodes]="campaignOptions()"
                           [selectedKeys]="action.campaign ? [action.campaign] : []"
                           [enableSearch]="true"
                           placeholder="Seleccione campaña"
                           (selectionChange)="onCampaignSelectionChange(i, $event)"
                        ></app-tree-select>
                     </div>

                     <div class="flex justify-content-end mt-2">
                        <p-button
                           [label]="'DATA.MODULES.INSPECTORS.MAKE_OUTBOUND_CALL.CONFIG.ACTIONS.SAVE_RULE' | translate"
                           icon="pi pi-check"
                           size="small"
                           (onClick)="saveAction(i)"
                        ></p-button>
                     </div>
                  </div>
               </div>
            </div>
         </section>

         <p-messages *ngIf="errors().length > 0" severity="error" [closable]="false">
            <ng-template pTemplate="content">
               <div class="flex flex-column gap-1">
                  <div *ngFor="let error of errors()">
                     {{ getErrorMessage(error) }}
                  </div>
               </div>
            </ng-template>
         </p-messages>
      </div>
   </div>
</div>
